export default __webpack_public_path__ + "static/color-picker-role-do-2aeb2f580859e8a4bf337147b761e49311f90cd066b507e8d2e6df9067f17def.png";